import { Link } from 'react-router-dom'
import { ComingSoonBanner } from '../components/Alert'
import { EmptyState } from '../components/States'
import { useCompanies } from '../companies/useCompanies'

export function BackupPage() {
  // Only live companies: a backup reads QuickBooks, which a disconnected
  // company's dead token cannot do.
  const { connected } = useCompanies()

  return (
    <div className="wrap">
      <div className="phead">
        <div>
          <div className="crumb">
            <Link to="/app">Home</Link> / Backup
          </div>
          <h2>Backup</h2>
          <p className="fs13 muted" style={{ margin: '6px 0 0' }}>
            A dated snapshot of every transaction and list in the company, written to a workbook you
            can keep.
          </p>
        </div>
        <span className="spacer" />
        <span className="pill">0.1 credit per transaction</span>
      </div>

      <ComingSoonBanner feature="Backup" />

      <div className="grid2" style={{ alignItems: 'start', gap: 18 }}>
        <div className="card">
          <div className="card-h">
            <h3>New backup</h3>
          </div>
          <div className="card-p">
            <div className="fgrp">
              <label className="fl" htmlFor="bkCompany">
                Company
              </label>
              <select className="inp" id="bkCompany">
                {connected.map((company) => (
                  <option key={company.id}>{company.companyName}</option>
                ))}
                {connected.length > 1 ? <option>All {connected.length} companies</option> : null}
              </select>
            </div>
            <div className="fgrp">
              <label className="fl">Period</label>
              <div className="row">
                <div className="fchip on">All time</div>
                <div className="fchip">This fiscal year</div>
                <div className="fchip">Custom</div>
              </div>
            </div>
            <div className="fgrp" style={{ margin: 0 }}>
              <label className="fl">Include</label>
              <label className="chk">
                <input type="checkbox" defaultChecked />
                <span>All transaction types (one sheet per entity)</span>
              </label>
              <label className="chk">
                <input type="checkbox" defaultChecked />
                <span>All lists — customers, vendors, items, chart of accounts</span>
              </label>
              <label className="chk">
                <input type="checkbox" defaultChecked />
                <span>QuickBooks internal Ids, so the file can be re-imported</span>
              </label>
              <label className="chk">
                <input type="checkbox" />
                <span>Attachments (adds a ZIP alongside the workbook)</span>
              </label>
            </div>
          </div>
          <div className="card-f">
            <span className="fs13 muted">
              The estimate needs the backup endpoint, which is not live yet.
            </span>
            <span className="spacer" />
            <button className="btn btn-p" type="button" disabled>
              Run backup
            </button>
          </div>
        </div>

        <div className="card">
          <div className="card-h">
            <h3>Backup history</h3>
          </div>
          <EmptyState
            icon="🗄"
            title="No backups taken"
            body="Completed snapshots will be listed here with their date, transaction count, size and expiry."
          />
          <div className="card-f">
            <span className="fs12 faint">
              Backups are stored encrypted and expire after 90 days.
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
